import {useState} from 'react';

import TextInput from '../textInput/TextInput';

import './PasswordInput.scss';

import PasswordInputEyeImage from '../../assets/password_input_eye.png'

interface IPasswordInput {
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    errorMessage?: string;
}

const PasswordInput: React.FC<IPasswordInput> = (props) => {

    const [hidden, setHidden] = useState(true);

    const onClick = () => {
        setHidden(!hidden);
    }

    return (
        <div className="eye_icon_parent">
            <TextInput
                placeHolder="Password"
                type={hidden ? 'password' : 'text'}
                value={props.value}
                onChange={props.onChange}
                errorMessage={props.errorMessage}
                isRequired={true}
            />
            <img className="eye_icon" src={PasswordInputEyeImage} onClick={onClick} alt={"Image not found"}/>
            {/* <i
                className="bi bi-eye eye_icon" 
                style={{
                    padding: '10px', 
                    cursor: 'pointer'
                }} 
                onClick={onClick}></i> */}
        </div>
    )
}

export default PasswordInput;